// extracted by mini-css-extract-plugin
export default {"wrapper":"cookieBannerPanelActionArea_wrapper"};